import { WSPillProps } from "@wingspanhq/fe-component-library";
import {
  PayeeRequirement,
  RequirementStatus
} from "@wingspanhq/wingspan-api-sdk";

import { selectorIsRequirementArchived } from "../selectors/selectorIsRequirementArchived";
import { selectorIsRequirementExpiringSoon } from "../selectors/selectorIsRequirementExpiringSoon";
import { selectorIsRequirementPostApproval } from "../selectors/selectorIsRequirementPostApproval";
import { RequirementContextType } from "../types";

export const extendRequirementStatusPill = (
  requirement: PayeeRequirement,
  requirementContextType: RequirementContextType,
  originalPill: WSPillProps
): WSPillProps => {
  const isReadyForApprove =
    requirement.status === RequirementStatus.PENDING_PAYER_REVIEW;

  const isExpiringSoon = selectorIsRequirementExpiringSoon(requirement);

  const isPostApproval = selectorIsRequirementPostApproval(requirement);

  const isArchived = selectorIsRequirementArchived(requirement);

  if (isArchived) {
    return {
      theme: "neutral",
      text: "Archived",
      icon: "archive"
    };
  }

  if (
    isExpiringSoon &&
    requirementContextType === RequirementContextType.Payer
  ) {
    return {
      theme: "warning",
      text: "Action required",
      icon: "time"
    };
  }

  if (isReadyForApprove) {
    if (requirementContextType === RequirementContextType.Payee) {
      return {
        theme: "warning",
        text: "Action required",
        icon: true
      };
    } else {
      return {
        theme: "neutral",
        text: "Awaiting client",
        icon: "time"
      };
    }
  } else if (isPostApproval) {
    if (requirement.status === RequirementStatus.COMPLETED) {
      return {
        theme: "success",
        text: "Complete",
        icon: true
      };
    } else {
      return {
        theme: "error",
        text: "Rejected",
        icon: true
      };
    }
  }

  return originalPill;
};
